import React, { FC, useContext, useMemo, useState } from "react";
import Accordion from "../accordion/accordion";
import { FieldTemplateProps } from "@rjsf/utils";
import { SearchContext } from "../../constants/contexts";
import styles from "../../pages/tenants/tenants.module.css";

export const AccordionFieldArray: FC<FieldTemplateProps> = ({ children, label }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { term } = useContext(SearchContext);

  const hasMatchingItems = useMemo(() => {
    if (!term) return true;

    return label.toLowerCase().startsWith(term.toLowerCase());
  }, [term, children]);

  if (!hasMatchingItems) {
    return <div className={styles.hiddenField}></div>;
  }

  return (
    <Accordion header={label} isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed((prev) => !prev)}>
      {children}
    </Accordion>
  );
};
